import React, { useState } from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../animations/variants";

import { useSelector } from "react-redux";
import { introText } from "../../i18n/intro";

const Intro = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = introText[lang];

  const [playVideo, setPlayVideo] = useState(false);

  return (
    <section className="py-32 px-6 bg-darkbg text-white overflow-hidden min-h-screen flex items-center justify-center  ">
      <div className="max-w-6xl mx-auto text-center  mt-10">
        {/* HEADING */}
        <motion.h2
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="text-4xl font-heading text-neonYellow animate-neonFlicker"
        >
          OUR STORY
        </motion.h2>

        {/* IMAGE */}

        {/* PARAGRAPH */}
        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          transition={{ delay: 0.3 }}
          viewport={{ once: true, amount: 0.3 }}
          className="mt-4 text-md text-text leading-relaxed max-w-5xl "
        >
          Saigon Star, a family ran Vietnamese restaurant, we have been serving
          Christchurch locals since 2005. Tucked in the corner of Christchurch
          most busiest intersection in Riccarton, there has been many great
          memories watching people find Saigon Star as their go to quick lunch
          hour destination, their weekly Vietnamese dinner fix. We are so proud
          & happy to be able to continue to serve the community with our new
          launch of our brand.{" "}
        </motion.p>
        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          transition={{ delay: 0.3 }}
          viewport={{ once: true, amount: 0.3 }}
          className="mt-4 text-md text-text leading-relaxed"
        >
          Much love,
        </motion.p>
        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          transition={{ delay: 0.3 }}
          viewport={{ once: true, amount: 0.3 }}
          className="mt-4 text-md text-text leading-relaxed"
        >
          SAIGON STAR TEAM
        </motion.p>
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          transition={{ delay: 0.15 }}
          viewport={{ once: true, amount: 0.3 }}
          className="mt-10 w-full max-w-6xl mx-auto rounded-xl overflow-hidden shadow-lg"
        >
          {!playVideo ? (
            /* COVER IMAGE */
            <div
              className="relative w-full aspect-video cursor-pointer group"
              onClick={() => setPlayVideo(true)}
            >
              <img
                src="/saigonstar/bghero.webp" // 👈 cover image
                alt="Saigon Star Story"
                className="w-full h-full object-cover"
              />

              {/* DARK OVERLAY */}
              <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition" />

              {/* PLAY BUTTON */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-20 h-20 rounded-full bg-white/90 flex items-center justify-center shadow-xl group-hover:scale-110 transition">
                  <svg
                    className="w-8 h-8 text-black ml-1"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </div>
              </div>
            </div>
          ) : (
            /* VIDEO */
            <div className="relative w-full aspect-video">
              <iframe
                className="absolute inset-0 w-full h-full"
                src="https://www.youtube.com/embed/b6gjBCXXPzM?autoplay=1"
                title="Saigon Star Story"
                frameBorder="0"
                allow="autoplay; encrypted-media; picture-in-picture"
                allowFullScreen
              />
            </div>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default Intro;
